import type { MyTask } from "@/hooks/use-my-tasks";

// Feedback (Erik): «Behandlede oppgaver» skal grupperes per prosjekt som
// «Mine tildelte oppgaver», ikke vises som en flat liste. Innen et prosjekt
// vises oppgavene i budsjett-/fase-rekkefølge (pre → prod → post → reise).
const PHASE_ORDER: Record<string, number> = { preprod: 0, production: 1, postprod: 2, reise: 3 };

/** Grupperer oppgaver per prosjekt, fase-sortert (pre → prod → post → reise) innen hvert. */
export function groupByProject(tasks: MyTask[]): [string, MyTask[]][] {
  const sorted = [...tasks].sort(
    (a, b) => (PHASE_ORDER[a.phase ?? ""] ?? 9) - (PHASE_ORDER[b.phase ?? ""] ?? 9),
  );
  return Array.from(
    sorted.reduce((map, t) => {
      const list = map.get(t.project_id) ?? [];
      list.push(t);
      map.set(t.project_id, list);
      return map;
    }, new Map<string, MyTask[]>()),
  );
}
